import {
  DEFAULT_SELECTED_INSURANCE_ISSUER_QUERY,
  FEATURED_DATA_QUERY,
  AUTOCOMPLETE_DATA_QUERY,
} from './GlobalInsuranceIssuerSelectWithData';
import InsuranceIssuerSelectWithoutData from './InsuranceIssuerSelect';
import DiInsuranceIssuerSelectWithoutData from './DiInsuranceIssuerSelect';
import InsuranceIssuerSelectWithData, {
  PROVIDER_INSURANCE_COVERAGE_QUERY,
  DiInsuranceIssuerSelectWithData,
} from './InsuranceIssuerSelectWithData';

export {
  InsuranceIssuerSelectWithoutData,
  DiInsuranceIssuerSelectWithoutData,
  DiInsuranceIssuerSelectWithData,
  DEFAULT_SELECTED_INSURANCE_ISSUER_QUERY,
  FEATURED_DATA_QUERY,
  AUTOCOMPLETE_DATA_QUERY,
  PROVIDER_INSURANCE_COVERAGE_QUERY,
};

export default InsuranceIssuerSelectWithData;
